"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormPageButtonExternalLink = void 0;
var FormPageButtonExternalLink;
(function (FormPageButtonExternalLink) {
    FormPageButtonExternalLink.TargetEnum = {
        Blank: '_blank',
        Self: '_self',
        Top: '_top',
        Parent: '_parent'
    };
})(FormPageButtonExternalLink = exports.FormPageButtonExternalLink || (exports.FormPageButtonExternalLink = {}));
